/* eslint-disable */
/**
 * Common request actions in the API.
 *
 * =====================================
 */

import auth from '@/services/auth'
import axios from 'axios'

/**
 * Initial config for http request
 *
 * @param String baseURL
 * @return {*} http
 */
const http = (baseURL) => {
  const http = axios.create({
    baseURL,
    headers: { Authorization: `Bearer ${auth.getAccessToken()}` }
  })

  // Refreshes token before any request
  http.interceptors.request.use(async config => {
    auth.tokenIsExpired() && await auth.refreshToken()

    config.headers.Authorization = `Bearer ${auth.getAccessToken()}`

    return config
  })

  return http
}

export default {
  /**
   * Display a list of the resource.
   *
   * @param String baseURL
   * @param String  url
   * @return Array result
   */
  async get ({ state }, { baseURL, url }) {
    const result = await http(baseURL).get(url)

    return result
  },

  /**
   * Search for resource.
   *
   * @param String baseURL
   * @param String  url
   * @param Object params
   * @return {*} result
   */
  async search ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).get(`${url}/search`, { params: data })

    return result
  },

  /**
   * Paginate for resource.
   *
   * @param String baseURL
   * @param String  url
   * @params Object params
   * @return {*} result
   */
  async paginate ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).get(`${url}/paginate`, { params: data })

    return result
  },

  /**
   *Display Specific resource
   *
   * @param String baseURL
   * @param String url
   * @param int id
   * @return {*} result
   */
  async show ({ state }, { baseURL, url, id, data = null }) {
    const result = await http(baseURL).get(`${url}/${id}`, { params: { ...data } })

    return result
  },

  /**
   *Display Specific resource from edit
   *
   * @param String baseURL
   * @param String url
   * @param int id
   * @return {*} result
   */
  async edit ({ state }, { baseURL, url, id }) {
    const result = await http(baseURL).get(`${url}/${id}/edit`)

    return result
  },

  /**
   *Store new data in resource
   *
   * @param String baseURL
   * @param String url
   * @param int id
   * @return {*} result
   */
  async store ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).post(url, data)

    return result
  },

  /**
   *Update data in resource
   *
   * @param String baseURL
   * @param String url
   * @param String id
   * @param {payload} payload
   * @return {*} result
   */
  async update ({ state }, { baseURL, url, id, data }) {
    const result = await http(baseURL).put(`${url}/${id}`, data)

    return result
  },

  /**
   *Remove data in resource
   *
   * @param String baseURL
   * @param String url
   * @param int id
   * @param {payload} payload
   * @return boolean result
   */
  async destroy ({ state }, { baseURL, url, id }) {
    const result = await http(baseURL).delete(`${url}/${id}`)

    return result
  },

  /**
   * Ordinary Post request to API
   *
   * @param {*} payload
   * @return {*} result
   */
  async post ({ baseURL, url, data = null, config }) {
    const result = await http(baseURL).post(url, data, config)

    return result
  },

  /*
   * Generate events to be placed in calendar view.
   */
  async calendar ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).post(url, data)

    return result
  },

  /**
   * Move all assigned trainers to another cycle.
   */
  async bulkUpdate ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).post(url, data)

    return result
  },

  /**
   * Assign all trainers to cycle.
   */
  async bulkStore ({ state }, { baseURL, url, data }) {
    const result = await http(baseURL).post(url, data)

    return result
  },

  /**
   * Upload Request
   *
   * @param {*} payload
   * @return result
   */
  async upload ({ baseURL, url, data }) {
    const result = await http(baseURL).post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return result
  },

  /**
   * Download Request
   *
   * @param {*} payload
   * @return result
   */
  async download ({ baseURL, url, data }) {
    const result = await http(baseURL).post(url, data, {
      'responseType': 'arraybuffer'
    })

    return result
  }

}
